import { Component, OnInit } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { map, Observable, Subscription } from 'rxjs';
import moment from  'moment-timezone/builds/moment-timezone-with-data-1970-2030.min.js';
import { AuthService } from 'src/app/services/auth.service';
import { User } from 'src/app/auth/user';
import { ConfigService } from 'src/app/shared/config';
import { AnnouncementService } from '../../services/announcement.service';
import { AnnouncementFormComponent } from './announcement-card/announcement-form.component';

interface Announcement {
    id: string;
    priority: string;
    announcement: string;
    startTime: string;
    active: string;
    endTime: string;
    systems: string[];
    type : string;
    windowColor?: string;
    textColor?: string;
}

@Component({
    selector: 'app-announcement-list',
    templateUrl: './announcement-list.component.html',
    styleUrls: ['./announcement-list.component.css'],
})
export class AnnouncementListComponent implements OnInit {
    announcementSub: Observable<any>;
    user: User; // Declare the 'user' property
    announcementArr: any[] = []; // Declare the 'announcementArr' variable
    systems: any[] = [];
    announcementByDay: { [key: string]: any[] } = {};
    systemsMap: { [key: string]: Announcement[] } = {};
    usedKampanje: Announcement[] = [];
    constructor(
        private announcementService: AnnouncementService,
        public dialog: MatDialog,
        private auth: AuthService,


    ) {
        this.loadSystems();

        this.auth.user$.subscribe(user => this.user = user)
        this.loadannouncement();
    }


    ngOnInit(): void {

    }


    loadannouncement(): void {

        this.announcementSub = this.announcementService.getAnnouncements().pipe(map(sp => {
            return sp.map((doc) => {
                return { id: doc.payload.doc.id, ...doc.payload.doc.data() }
            })
            // 
        }))
        this.announcementSub.subscribe(data => {
            this.announcementArr = data;
            this.usedKampanje = this.announcementArr.filter((announcement: Announcement) => announcement['type'] === 'kampanje');
        });
    }

    loadSystems(): void {
        this.announcementService.getSystems().subscribe((data: any) => {
            this.systems = data;
        })
    }


    createannouncement(): void {
        const dialogRef = this.dialog.open(AnnouncementFormComponent, {
            width: '600px', // Set the width of the dialog
            data: { systems: this.systems, usedKampanje: this.usedKampanje }
        });
        dialogRef.afterClosed().subscribe((formValue) => {
            if (formValue) {
                const cleanedFormValue = this.removeUndefinedValues(formValue);
    
                this.announcementService.addAnnouncement(cleanedFormValue).then(() => {
                    // Handle success
                }).catch((error) => {
                    // Handle error
                });
    
            }
        });
    }
    
    removeUndefinedValues(obj: any): any {
        const cleanedObj = {};
        for (const key in obj) {
            if (obj.hasOwnProperty(key) && obj[key] !== undefined) {
                cleanedObj[key] = obj[key];
            }
        }
        return cleanedObj;
    }


    editAnnouncement(eventData): void {
        const dialogRef = this.dialog.open(AnnouncementFormComponent, {
            width: '600px', // Set the width of the dialog
            data: {
                eventData, systems: this.systems,
                usedKampanje: this.usedKampanje
            }, // Pass any data to the dialog if needed
        });
        dialogRef.afterClosed().subscribe((formValue) => {
            if (formValue) {
                const cleanedFormValue = this.removeUndefinedValues(formValue);
                this.announcementService.updateAnnouncement(eventData.id, cleanedFormValue).then(() => {
                    // Handle success
                }).catch((error) => {
                    // Handle error
                });
            }
        });
    }

    deleteAnnouncement(announcement): void {
        this.announcementService.deleteAnnouncement(announcement.id).then(() => {
            // Handle success

        }).catch((error) => {
            // Handle error
        });
    }


    parseTime(timeStr: string, referenceDate: Date): Date {
        // Expected format: "HH:MM AM/PM"
        const [timePart, modifier] = timeStr.split(' ');
        let [hours, minutes] = timePart.split(':').map(Number);

        if (modifier === 'PM' && hours < 12) {
            hours += 12;
        }
        if (modifier === 'AM' && hours === 12) {
            hours = 0;
        }

        // Create a new Date for the same day as referenceDate, in local time.
        // (We already converted the current time from Oslo so this works for our comparison.)
        return new Date(
            referenceDate.getFullYear(),
            referenceDate.getMonth(),
            referenceDate.getDate(),
            hours,
            minutes
        );
    }



}


